module.exports = __webpack_public_path__ + "static/media/password.2bf15b22.svg";